var globalIsFinite = require('../internals/global').isFinite; // `Number.isFinite` method
// https://tc39.github.io/ecma262/#sec-number.isfinite


module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};